import { uuidv4 } from '@core/helpers/uuidv4'
import {
  EnumFunnelTrackingCookies,
  getCookieWithFallback,
  setCookieWithFallback,
} from '@core/tracking/funnelTracking'

/**
 *
 */
export function persistGuestId() {
  const guestId =
    getCookieWithFallback(EnumFunnelTrackingCookies.FW_GUEST_ID)?.value ||
    uuidv4()

  if (guestId) {
    setCookieWithFallback(EnumFunnelTrackingCookies.FW_GUEST_ID, guestId)
  }
}
